import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Share02 = function Share02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M7 11c-.93 0-1.395 0-1.7765.1022a3 3 0 0 0-2.1213 2.1213C3 13.605 3 14.07 3 15v1.2c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.7202 21 17.8802 21 16.2V15c0-.93 0-1.395-.1022-1.7765a3 3 0 0 0-2.1213-2.1213C18.395 11 17.93 11 17 11m-1-4-4-4m0 0L8 7m4-4v12"
    })
  }));
};
export default Share02;